<script setup>
    // Vue
    import { useRouter, useRoute } from 'vue-router';
    import { computed, ref } from 'vue';
    import { onMounted } from 'vue';
    //import { useHead } from 'unhead';

    // Store
    //import { useCommonStore } from '@/stores/common/commonStore';
    import { useHeaderStore } from '@/stores/header/headerStore';
    import { useLoginStore } from '@/stores/login/loginStore';

    // Utils
    import Utils from '@/commonProject/helpers/utils.js';

    // 遷移情報
    const route = useRoute();
    const router = useRouter();

    const headerStore = useHeaderStore();
    const loginStore = useLoginStore();
    //const commonStore = useCommonStore();

    // ユーザー情報のエリアをクリックする動作の制御フラグ
    let openUserMenuFlag = ref(false);

    // ログインしたユーザーのベンダーに応じて画面ヘッダー部の表現を制御する。
    // 1：通常ヘッダー
    // 2：TMS用ヘッダー
    const headerType = ref(1);

    // ログインユーザーがM01権限を保持している場合は、本画面の一部機能を表示する。
    const isM01AuthorityUserLoggedin = ref(false);

    // ログインユーザーがM02権限を保持している場合は、本画面の一部機能を表示する。
    const isM02AuthorityUserLoggedin = ref(false);

    // ----------------------------
    // ログイン後に表示するエリア判定(算術プロパティ)
    // ----------------------------
    const afterLoginDisplay = computed(() => {
        // ヘッダー部の各画面遷移エリアはログイン後に表示する。
        // 以下の画面のみ表示しない。
        switch (route.name) {
            // 表示しない画面の一覧。
            case 'login':
            case 'signinMfa':
            case 'setupPasswordApply':
            case 'setupPasswordComplete':
            case 'signinResetApply':
            case 'signinResetPassword':
            case 'signinResetComplete':
            case 'signinUseridApply':
            case 'signinUseridComplete':
            case 'setupAgree':
            case 'maintenance':
            case 'error':
            case 'pageNotFound':
            case 'login3':
                return false;
            default:
                return true;
        }
    });

    /**
     * ログアウト
     */
    async function logout() {
        // ログアウト処理を実行する。
        await headerStore.logoutAction();
    }

    async function openUserMenu() {
        if (openUserMenuFlag.value) {
            openUserMenuFlag.value = false;
        } else {
            openUserMenuFlag.value = true;
        }
    }
    function userDetailLink() {
        // ユーザー情報確認画面に遷移する。
        router.push('/user/detail');
    }

    // ----------------------------
    // ライフサイクル
    // ----------------------------
    onMounted(async () => {
        let vendorId = '1';
        if (!Utils.isNullEmpty(route.query.vid)) {
            // ベンダーIDをloginStoreに代入する。
            vendorId = route.query.vid;
        } else {
            switch (true) {
                case loginStore.getVendorId === '2' || loginStore.getVendorId === 't2':
                    {
                        // TMSのベンダーかどうか判定する。
                        vendorId = '2';
                    }
                    break;

                default:
                    {
                        // ARMのベンダーかどうか判定する。
                        vendorId = '1';
                    }
                    break;
            }
        }

        // ログインしたユーザーのベンダーに応じてヘッダー部を変更する。
        switch (true) {
            case vendorId === '2' || vendorId === 't2':
                {
                    // TMSのベンダーかどうか判定する。
                    headerType.value = 2;
                }
                break;

            default:
                {
                    headerType.value = 1;
                }
                break;
        }

        // ログインしたユーザーのベンダーに応じてヘッダー部を再構成する。
        switch (headerType.value) {
            case 1:
                {
                    // ログインしたユーザーがARMの場合。

                    // 現在のベンダーIDのヘッダーを削除する。

                    // ARMのヘッダー。
                    const element1 = document.getElementById('PageStyleSheet1');
                    if (!Utils.isNullEmpty(element1)) {
                        element1.remove();
                    }

                    // TMSのヘッダー。
                    const element2 = document.getElementById('PageStyleSheet2');
                    if (!Utils.isNullEmpty(element2)) {
                        element2.remove();
                    }

                    // ARMのヘッダーを生成する。
                    const head = document.head;
                    head.insertAdjacentHTML('beforeEnd', '<link id="PageStyleSheet1" rel="stylesheet" href="/css/common_manage_t1.css" media="all">');
                }
                break;
            case 2:
                {
                    // ログインしたユーザーがTMSの場合。

                    // 現在のベンダーIDのヘッダーを削除する。

                    // ARMのヘッダー。
                    const element1 = document.getElementById('PageStyleSheet1');
                    if (!Utils.isNullEmpty(element1)) {
                        element1.remove();
                    }

                    // TMSのヘッダー。
                    const element2 = document.getElementById('PageStyleSheet2');
                    if (!Utils.isNullEmpty(element2)) {
                        element2.remove();
                    }

                    // TMSのヘッダーを生成する。
                    const head = document.head;
                    head.insertAdjacentHTML('beforeEnd', '<link id="PageStyleSheet2" rel="stylesheet" href="/css/common_manage_t2.css" media="all">');
                }
                break;

            default:
                {
                    // ログインしたユーザーが上記以外の場合。

                    // 現在のベンダーIDのヘッダーを削除する。

                    // ARMのヘッダー。
                    const element1 = document.getElementById('PageStyleSheet1');
                    if (!Utils.isNullEmpty(element1)) {
                        element1.remove();
                    }

                    // TMSのヘッダー。
                    const element2 = document.getElementById('PageStyleSheet2');
                    if (!Utils.isNullEmpty(element2)) {
                        element2.remove();
                    }
                }
                break;
        }

        // ログインユーザーがM01権限を保持しているかStoreから取得して判定する。
        // ログイン中のユーザーを判定し、表示フラグを有効にする。
        if (loginStore.userM01Flag) {
            isM01AuthorityUserLoggedin.value = true;
        }

        // ログインユーザーがM02権限を保持しているかStoreから取得して判定する。
        // ログイン中のユーザーを判定し、表示フラグを有効にする。
        if (loginStore.userM02Flag) {
            isM02AuthorityUserLoggedin.value = true;
        }
    });
</script>

<style></style>

<template>
    <template v-if="afterLoginDisplay">
        <!--ログイン後のヘッダー部-->
        <header>
            <ul>
                <li id="title">
                    <template v-if="headerType === 1">
                        <!--通常のヘッダー-->
                        <h1>&nbsp;</h1>
                        <h2>{{ $t('header.parts.title2') }}</h2>
                    </template>
                    <template v-else-if="headerType === 2">
                        <!--TMSのヘッダー-->
                        <h1>{{ $t('header.parts.titleTms') }}</h1>
                        <h2>{{ $t('header.parts.title2') }}</h2>
                    </template>
                </li>
                <li id="headerLinks">
                    <ul>
                        <li>
                            <!--メニュー-->
                            <RouterLink :to="{ name: 'home' }" class="btnText">{{ $t('header.parts.button6') }}</RouterLink>
                        </li>
                        <template v-if="isM02AuthorityUserLoggedin">
                            <li>
                                <!--利用者の管理-->
                                <RouterLink :to="{ name: 'managementlist' }" class="btnText">{{ $t('header.parts.button1') }}</RouterLink>
                            </li>
                        </template>
                        <template v-if="isM01AuthorityUserLoggedin">
                            <li>
                                <!--管理者の設定-->
                                <RouterLink :to="{ name: 'companyManagementList' }" class="btnText">{{ $t('header.parts.button2') }}</RouterLink>
                            </li>
                        </template>
                        <template v-if="isM01AuthorityUserLoggedin">
                            <li>
                                <!--ご契約情報/各種設定-->
                                <RouterLink :to="{ name: 'settings' }" class="btnText">{{ $t('header.parts.button3') }}</RouterLink>
                            </li>
                        </template>
                    </ul>
                </li>
                <li id="userInformation" :class="{ user: true, open: openUserMenuFlag }" @click="openUserMenu">
                    <span class="userName">{{ loginStore.nameKjLs + ' ' + loginStore.nameKjFs }}</span>
                    <ul class="userMenu">
                        <li>
                            <button type="button" class="btnText" id="userInfo" @click="userDetailLink">{{ $t('header.parts.button4') }}</button>
                        </li>
                        <li>
                            <button type="button" class="btnText" id="btnLogout" @click="logout">{{ $t('header.parts.button5') }}</button>
                        </li>
                    </ul>
                </li>
            </ul>
        </header>
    </template>
    <template v-else>
        <!--ヘッダー部（ログイン前）-->
        <header>
            <ul>
                <li id="title">
                    <template v-if="headerType === 1">
                        <!--通常のヘッダー-->
                        <h1>&nbsp;</h1>
                        <h2>{{ $t('header.parts.title2') }}</h2>
                    </template>
                    <template v-else-if="headerType === 2">
                        <!--TMSのヘッダー-->
                        <h1>{{ $t('header.parts.titleTms') }}</h1>
                        <h2>{{ $t('header.parts.title2') }}</h2>
                    </template>
                </li>
            </ul>
        </header>
    </template>
</template>
